import {Typography} from '@mui/material';
import {t} from 'i18next';

interface Props {
  projectName: string;
}

const stringPath = 'projectCreation.progressHeader.';

const ProjectProgressHeaderContent: React.FC<Props> = ({projectName}) => {
  return (
    <div className="project-progress-header-content-container">
      <Typography className="typo-text display3_size title-label">
        {t(stringPath + 'title')}
      </Typography>
      <Typography className="typo-text body2_size sub-title-lable">
        {t(stringPath + 'weSettingUP')} <br /> <span>{projectName + '.'}</span>
      </Typography>
      <br />
      <Typography className="typo-text body3_size query-contact-label">
        {t(stringPath + 'haveQuestionContact')}
      </Typography>
    </div>
  );
};

export default ProjectProgressHeaderContent;
